import type { ErrorItem } from "@auth0/auth0-acul-react/types";
import {
  PropHeroText,
  TEXT_COLOR,
  TEXT_TYPOGRAPHY,
  TEXT_WEIGHT,
} from "@prophero-ds/react-components";

interface GeneralErrorAlertProps {
  errors: ErrorItem[];
  hasError: boolean;
  onDismiss: (id: string) => void;
  fallbackMessage: string;
  dismissLabel: string;
}

function GeneralErrorAlert({
  errors,
  hasError,
  onDismiss,
  fallbackMessage,
  dismissLabel,
}: GeneralErrorAlertProps) {
  if (!hasError || errors.length === 0) return null;

  return (
    <div className="rounded-md border border-red-200 bg-red-50 p-3">
      {errors.map((error) => (
        <div key={error.id} className="flex items-start justify-between gap-3">
          <PropHeroText
            typography={TEXT_TYPOGRAPHY["Text-md"]}
            weight={TEXT_WEIGHT.medium}
            color={TEXT_COLOR.primary}
            className="text-red-700"
          >
            {error.message || fallbackMessage}
          </PropHeroText>
          <button
            type="button"
            id={`error-dismiss-${error.id}`}
            className="text-xs text-red-700 underline"
            onClick={() => onDismiss(error.id)}
          >
            {dismissLabel}
          </button>
        </div>
      ))}
    </div>
  );
}

export default GeneralErrorAlert;
